import { FormInstance } from "antd";
import { createContext, Dispatch, SetStateAction } from "react";
import { 
  CalculateFinalPrizeServiceResponse, 
  CarQuotationCoverage, 
  CarQuotationServiceResponse, 
  CarReQuotationServiceResponse, 
  GetCommertialsConditionsResponse, 
  Version 
} from "../../../../../../../../shared/interfaces";

interface WizardDataFormContextProps {
  handleTabErrors:                    (errorFields: any[], tabPrefix: string[], tabName: string) => void

  quotationForm:                      any | undefined;
  setQuotationForm:                   Dispatch<SetStateAction<any | undefined>>

  stepTwoForm:                        FormInstance<any>;
  stepThreeForm:                      FormInstance<any>;

  quotationResponseByCar:             Array<{ componentId: string, quotationResponse: CarQuotationServiceResponse }>;
  setQuotationResponseByCar:          Dispatch<SetStateAction<Array<{ componentId: string, quotationResponse: CarQuotationServiceResponse }>>>;

  reQuotationResponseByCar:           Array<{ componentId: string, reQuotationResponse: CarReQuotationServiceResponse }>;
  setReQuotationResponseByCar:        Dispatch<SetStateAction<Array<{ componentId: string, reQuotationResponse: CarReQuotationServiceResponse }>>>;

  coverageSelectedByVehicle:          Array<{ componentId: string, coverageSelected: CarQuotationCoverage }>;
  setCoverageSelectedByVehicle:       Dispatch<SetStateAction<Array<{ componentId: string, coverageSelected: CarQuotationCoverage }>>>;

  finalPrize:                         CalculateFinalPrizeServiceResponse | undefined;
  setFinalPrize:                      Dispatch<SetStateAction<CalculateFinalPrizeServiceResponse | undefined>>;

  versionSelectedByVehicle:           Array<{ componentId: string, versionSelected: Version }>;
  setVersionSelectedByVehicle:        Dispatch<SetStateAction<Array<{ componentId: string, versionSelected: Version }>>>; 

  /** Flag for determine if article has scoring */
  articleHasScoring:                  boolean;

  commertialConditions:               GetCommertialsConditionsResponse | undefined;


  //* Methods

  selectCoveragePerVehicle:           (coverageCode: string, componentId: string) => Promise<void>;

  calculateFinalPrize:                (componentId: string) => Promise<void>;

  getCoveragesPerVehicle:             (componentId: string) => Array<CarQuotationCoverage> | undefined;

  removeSelectedCoverageByVehicle:    (componentId: string) => void;

  removeInfoOfVehicle:                (componentId: string) => void;
}

export const WizardDataFormContext = createContext({} as WizardDataFormContextProps);